import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Tooltip from '@mulesoft/anypoint-components/lib/Tooltip';
import { AssetImage, AssetType } from '@mulesoft/exchange-ui-components';
import { getIconURL, getPath } from '~/utils/routes';
import styles from './Dependency.css';

const Dependency = ({ asset, onDependencyClick }) => {
  const disabled = !hasViewPermissions(asset);
  const dependencyBodyClass = classNames(
    styles.dependencyBody,
    {
      [styles.disabled]: disabled
    },
    'dependency'
  );

  const dependencyBody = (
    <div
      aria-describedby={disabled ? 'page-limit-tooltip-text' : null}
      className={dependencyBodyClass}
      data-test-id="asset-dependency-body"
    >
      <AssetImage type={asset.type} icon={getIconURL(asset)} alt={asset.name} />
      <div className={styles.content} data-test-id="asset-dependency-content">
        <div data-test-id="dependency-asset-name" className={styles.name}>
          {asset.name}
        </div>
        <div data-test-id="dependency-asset-version" className={styles.version}>
          {asset.version}
        </div>
        <AssetType type={asset.type} />
      </div>
    </div>
  );

  const renderTooltipContent = 'You don’t have permissions to view this asset.';

  return (
    <div className={styles.dependency} data-test-id="asset-dependency">
      <Tooltip
        display-if={disabled}
        className={styles.tooltip}
        content={renderTooltipContent}
      >
        {dependencyBody}
      </Tooltip>

      <Link
        display-if={!disabled}
        to={getPath('page', asset)}
        onClick={onDependencyClick}
      >
        {dependencyBody}
      </Link>
    </div>
  );
};

function hasViewPermissions(asset) {
  return asset.permissions && asset.permissions.length;
}

Dependency.propTypes = {
  asset: PropTypes.object.isRequired,
  onDependencyClick: PropTypes.func
};

Dependency.defaultProps = {
  onDependencyClick: () => {}
};

export default Dependency;
